import {
  dbTimeToJsTime,
  formattedDateTimeBasedOnTimezone,
} from "../../../utils/dateTime";


export const getDateKeyFromTimestamp = (
  timestampSeconds: number,
  timezone: string
): string =>
  formattedDateTimeBasedOnTimezone(
    dbTimeToJsTime(timestampSeconds),
    timezone,
    "yyyy-MM-dd"
  );


export const parseDateKey = (dateKey: string): Date => {
  const [year, month, day] = dateKey.split("-").map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
};

export const formatDateLabel = (dateKey: string): string =>
  new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  }).format(parseDateKey(dateKey));

export const todayDateKey = (): string => {
  const now = new Date();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");
  const day = `${now.getDate()}`.padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
};

// steps a dateKey forward or back by whole days
export const shiftDateKey = (dateKey: string, deltaDays: number): string => {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() + deltaDays);
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};
